import { io } from 'socket.io-client';

const SOCKET_URL = window.location.origin;

export const socket = io(SOCKET_URL, {
    autoConnect: true,
    reconnection: true,
    // CRIT-04 FIX: Pass initData to Backend socket server for authentication
    auth: {
        initData: typeof window !== 'undefined' && window.Telegram?.WebApp?.initData ? window.Telegram.WebApp.initData : null
    }
});

let currentUserId: string | number | null = null;

// Handle auto-rejoin on (re)connect
socket.on('connect', () => {
    if (currentUserId) {
        console.log('[Socket] Reconnected, re-joining user room:', currentUserId);
        socket.emit('join_user', currentUserId);
    }
});

export const connectUser = (userId: string | number) => {
    if (socket && userId) {
        currentUserId = userId;
        socket.emit('join_user', userId);
    }
};
